import Box from "ds/components/Box";
import Timestamp from "components/Timestamp";

import { CellComponentProps } from "../types";

type ApiKeysListItemCreatedAtCellProps = CellComponentProps;

const ApiKeysListItemCreatedAtCell = ({ apiKey }: ApiKeysListItemCreatedAtCellProps) => {
  return (
    <Box fullWidth gap="large">
      <Timestamp variant="p-body3" timestamp={apiKey.createdAt} />
    </Box>
  );
};

export default ApiKeysListItemCreatedAtCell;
